// Red marker shown on a menu item that has something waiting for the person to act on.
export default function NavDot({ count, className = "" }) {
  if (!count || count <= 0) return null;
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-red-500 text-white text-[11px] font-bold
                  min-w-[1.25rem] h-5 px-1.5 shadow ring-2 ring-red-500/30 ${className}`}
      aria-label={`${count} waiting for your action`} data-testid="nav-dot">
      {count > 99 ? "99+" : count}
    </span>
  );
}
